import PropTypes from 'prop-types'
import { routeParametersPropType } from '../route/route-parameters-prop-type'
import { addressPropType } from '../address/address-prop-type'
import { orderTemplatePropType } from '../orders/order-template-prop-type'

/**
 * This is the orderTourTemplatePropType data model type definition.
 *
 * @typedef {Object} OrderTourTemplate
 * @property {string} [description] - description of the order tour template
 * @property {Address} [endLocation] - The address of the end location of the tour.
 * @property {Boolean} isRoundTrip - round trip flag
 * @property {ISO8601} [lastModified] - timestamp of last change.
 * @property {string} [lastModifiedUserId] - user id of last change.
 * @property {string} name - name for the template.
 * @property {string} [orderScheduleTemplateId] - the id of the order tour template.
 * @property {OrderTemplate[]} [orderTemplates] - Array of order templates in the tour.
 * @property {string} [orderTemplatesCount] - number of order templates in this tour template
 * @property {RouteParameter} routeParameters - parameters for calculating the route
 * @property {Address} startLocation - The address of the start location of the tour.
 * @property {string} startTime - start time of the tour.
 */
export const orderTourTemplatePropType = PropTypes.shape({
    description: PropTypes.string,
    endLocation: addressPropType,
    isRoundTrip: PropTypes.bool.isRequired,
    lastModified: PropTypes.number,
    lastModifiedUserId: PropTypes.string,
    name: PropTypes.string.isRequired,
    orderScheduleTemplateId: PropTypes.string,
    orderTemplates: PropTypes.arrayOf(orderTemplatePropType),
    orderTemplatesCount: PropTypes.number,
    routeParameters: routeParametersPropType.isRequired,
    showUnproductiveTime: PropTypes.bool,
    startLocation: addressPropType.isRequired,
    startTime: PropTypes.string.isRequired
})
